// extracted by mini-css-extract-plugin
export default {"container":"IconedText_container__bywMz","iconContainer":"IconedText_iconContainer__XMS8C","text":"IconedText_text__Yud3x"};